import { all } from 'redux-saga/effects';
import GetOffers from './OffersSaga';
import GetUserData from './UserDataSaga';
import ChangeUserData from './ChangeUserDataSaga';
import ChangeUserPassword from './ManagePasswordSaga';
import ChangeDesign from './ChangeDesignSaga';
import GetOfferDetails from './OfferDetailsSaga';
import PostNewBet from './BetsSaga';
import GetNewBets from './NewBetsSaga';
import GetMyBets from './MyBetsSaga';
import GetInRealization from './InRealizationSaga';
import SetPickupDateSage from './SetPickUpDateSaga';
import SetTransferredForTransport from './SetTransferredForTransportSaga';
import SetVehiclePickedDateSaga from './SetVehiclePickedDateSaga';
import FetchArchiveAccepted from './FetchArchiveAccepted';
import fetchArchiveSold from './FetchArchiveSold';
import FetchChannels from './FetchChannelsSaga';
import FetchInvoicesSaga from './FetchInvoicesSaga';
import FetchConversations from './Conversations/FetchConversationsSaga';
import FetchSingleConversation from './Conversations/FetchSingleConversationSaga';
import FetchDesign from './FetchDesignSaga';
import SendConversationMessage from './Conversations/SendConversationMessageSaga';
import SetSeenByDealer from './Conversations/SetSeenByDealerSaga';
import CreateNewAd from './CreateNewAd';
import CreateChannelActivationSaga from './CreateChannelActivationSaga';
import AcceptBuyNowContract from './AcceptBuyNowContractSaga';
import SignOutSagaSaga from './SignOutSaga';
import FetchAdFormInitialDetails from './FetchAdFormInitialDetails';
import FetchAd from './FetchAd';
import FetchChannelActivation from './FetchChannelActivation';
import CreatePromotion from './CreatePromotion';
import FetchAds from './FetchAdsSaga';
import UpdateAd from './UpdateAd';
import DeactivatePromotion from './DeactivatePromotion';
import UpdatePromotion from './UpdatePromotion';
import FetchPromotion from './FetchPromotion';
import FetchPromotions from './FetchPromotions';
import RemoveAd from './RemoveAd';
import RemovePhoto from './RemovePhoto';
import GetBuyNowOffers from './BuyNowOffersSaga';
import SignIn from './SignInSaga';
import NewPasswordRequest from './NewPasswordSaga';
import ResetPassword from './ResetPasswordSaga';
import FetchNewOffersCount from './FetchNewOffersCount';

export default function* root() {
  yield all([
    CreateNewAd(),
    GetOffers(),
    GetUserData(),
    ChangeUserData(),
    ChangeUserPassword(),
    ChangeDesign(),
    CreateChannelActivationSaga(),
    GetOfferDetails(),
    PostNewBet(),
    GetNewBets(),
    GetMyBets(),
    GetInRealization(),
    SetPickupDateSage(),
    SetTransferredForTransport(),
    SetVehiclePickedDateSaga(),
    FetchArchiveAccepted(),
    fetchArchiveSold(),
    FetchInvoicesSaga(),
    FetchConversations(),
    FetchChannels(),
    FetchSingleConversation(),
    FetchDesign(),
    SendConversationMessage(),
    SetSeenByDealer(),
    AcceptBuyNowContract(),
    SignOutSagaSaga(),
    FetchAdFormInitialDetails(),
    FetchAd(),
    FetchChannelActivation(),
    CreatePromotion(),
    FetchAds(),
    UpdateAd(),
    DeactivatePromotion(),
    UpdatePromotion(),
    FetchPromotion(),
    FetchPromotions(),
    RemoveAd(),
    RemovePhoto(),
    GetBuyNowOffers(),
    SignIn(),
    NewPasswordRequest(),
    ResetPassword(),
    FetchNewOffersCount()
  ]);
}
